export const ROOT_PATH = '/';
export const HOME_PAGE_PATH = '/home';
export const LOGIN_PAGE_PATH = '/login';

export const DASHBOARD_PATH = 'dashboard';
export const ACTIVITY_PAGE_PATH = 'activity';
export const PROFILE_PAGE_PATH = 'profile';
